'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _field = require('../../field');

var Fields = _interopRequireWildcard(_field);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dynamický export
 *
 * Všechny existující třídy obalíme
 */

/**
 * Seznam custom export tříd
 */
var exclude = ['McField'];

var toExport = {};

(0, _keys2.default)(Fields).forEach(function (key) {
    if (exclude.indexOf(key) !== -1) {
        return;
    }

    var customProps = {};
    if ("Checkbox" === key) {
        customProps.check = true;
    }

    var value = Fields[key];

    var McReduxWrapp = function (_React$Component) {
        (0, _inherits3.default)(McReduxWrapp, _React$Component);

        function McReduxWrapp() {
            (0, _classCallCheck3.default)(this, McReduxWrapp);
            return (0, _possibleConstructorReturn3.default)(this, (McReduxWrapp.__proto__ || (0, _getPrototypeOf2.default)(McReduxWrapp)).apply(this, arguments));
        }

        (0, _createClass3.default)(McReduxWrapp, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(_Base2.default, (0, _extends3.default)({ componentClass: value }, this.props, customProps));
            }
        }]);
        return McReduxWrapp;
    }(_react2.default.Component);

    toExport[key] = McReduxWrapp;
});

/**
 * Přidání custom export třídy
 */
toExport['Base'] = _Base2.default;

exports.default = toExport;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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